<script setup lang="ts">
import TechnoFrame from "@/components/Common/TechnoFrame.vue";
import GameItemsPreview from "@/components/MainPage/PcVersion/GameItemsPreview.vue";
import MobilePreorderInfo from "@/components/MainPage/MobileVersion/PreorderInfoBlock/PreorderInfo.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'PreorderInfoBlockContentHolder',
})
</script>

<template>
    <div class="contentBox">
        <TechnoFrame
            :offset="5"
            :size-modifier="0.3"
        />

        <div class="contentHolder">
            <GameItemsPreview/>
            <MobilePreorderInfo/>
        </div>
    </div>
</template>

<style scoped lang="scss">
.contentBox {
    position: relative;
    width: 100%;
    max-width: 700px;
    background: rgba(15, 15, 15, 0.85);
    border-radius: 20px 20px 30px 30px;
    box-shadow: 0 0 20px 5px rgba(20, 20, 20, 1.0);

    background-image: v-bind('`url("/img/page/landing/main/bg/2.webp")`');
    background-size: cover;
    background-position: center center;
}

.contentHolder {
    width: 100%;
    padding: 30px 15px 35px 15px;
    overflow: hidden;

    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    align-items: center;
}
</style>
